module.exports = __webpack_public_path__ + "static/media/boss.5823f0fd.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/boss.jpg
 ** module id = 2
 ** module chunks = 0
 **/